import type { ContactFormData, ContactResponseApi } from 'src/models/contact';

import { performServerAPICall } from 'src/utils/server/ServerAPIUtils';

export const submitContactFormApi = async (
  contactFormFieldData: ContactFormData,
) => {
  return performServerAPICall<ContactResponseApi>({
    url: `contact`,
    method: 'post',
    data: contactFormFieldData,
  });
};
